<template>
    <div class="x-md" v-if="aItems.length > 0">
        <h2>学校设施</h2>
        <div>
            <div class="item" v-for="(item, index) in aItems" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>



<script setup>

const props = defineProps({
    data: Object
})
const aItems = ref([]);
const sItem = props.data.data.attributes.provide || "";
if(sItem){
    aItems.value = sItem.split(/,|，|\s+/g);
}
</script>

<style scoped>
.item{
    display:inline-block;
    padding:8px 16px;
    border-radius: 4px;
    border:1px solid #f4f5f6;
    font-size:14px;
    line-height:14px;
    height:14px;
    margin:7px;
}
</style>